export const RequiredIndicator = () => {
  return <span className='text-error'>*</span>
}
